
import { Component, OnInit, Input } from "@angular/core";

import { Noticia } from "src/app/interfaces/noticia.model";
import { Observable } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalInfoComponent } from "./modal-info.component";

@Component({
  selector: "app-secao-noticias",
  template: `
    <section id="noticias" class="noticias">
  <div class="container">
    <header class="section-header">
      <h3>Notícias</h3>
      <p>Notícias em destaque</p>
    </header>

    <app-spinner *ngIf="!noticias"></app-spinner>

    <div class="row noticias-cols" *ngIf="noticias && noticias.length > 0">
      <div class="col-md-3 wow fadeInUp" *ngFor="let noticia of noticias">
        <div class="noticias-col" routerLink="/noticias/{{ noticia.id }}">
          <div class="container-noticia">

            <!-- Data  -->
            <div class="img">
              <div class="icon">
                {{ noticia.data | date: "dd/MM" }}
              </div>
            </div>

            <!-- Imagem da notícia -->
            <img
              [src]="noticia.foto ? noticia.foto.file : '/assets/img/sem-imagem.png'"
              [alt]="noticia.titulo"
              class="img-rounded"
              style="height: 150px; width: 280px; object-fit: cover; border-radius: 0 100px 0 0; background-color: #e8e8e8;"
            />

            <!-- Título -->
            <h6>{{ noticia.titulo }}</h6>

            <!-- Conteúdo -->
            <div class="conteudo mt-2">
              <div [innerHTML]="noticia.conteudo"></div>
            </div>

            <!-- Botão "Ver mais" -->
            <button class="btn-toggle" (click)="noticia.expandido = !noticia.expandido">
              {{ noticia.expandido ? 'Ver menos' : 'Ver mais' }}
            </button>

          </div>
        </div>
      </div>
    </div>

    <!-- Botão de mais notícias -->
    <div class="text-center" *ngIf="noticias && noticias.length > 0">
      <a routerLink="noticias" class="modern-button mt-4">Outras Notícias</a>
    </div>

    <p *ngIf="noticias && noticias.length == 0">Nenhuma notícia a ser exibida.</p>
  </div>
</section>

  `,
 styleUrls: ["./secao-noticias.component.scss"]
})
export class SecaoNoticiasComponent implements OnInit {
  @Input() noticias: Noticia[];
  constructor(private modalService: NgbModal) { }

  ngOnInit() { }
}

